export default __webpack_public_path__ + "static/media/abouty-hero-shape.941ff96e.svg";